export const send_iframe_data = (iFrameObject)=> {
             

    window.parent.postMessage({ type: 'datalogics_shipment_created' }, '*');
    const message = {
        type: 'datalogics_shipment_created',
        data: iFrameObject
    };
    window.parent.postMessage(message, '*');


}